import { Navigate } from "react-router-dom";
import { readRememberedSide, sideHomePath, type PartsSide } from "../features/wholesale/side.js";
import { useSession, type Role } from "./AppProviders.js";
import { LOGIN_PATH } from "./RequireSession.js";

/**
 * Sends a signed-in person to the list their role starts on:
 * Parts (and the Parts manager) → the Work queue, or the wholesale Open
 * list when this browser last showed the wholesale side (spec 2026-09-17
 * §4.1 — the portal remembers the side per browser); advisors and
 * technicians → My vehicles; managers, foremen and dispatchers → All
 * active. Administration is a capability, not a role, so `isAdmin` never
 * changes the home, and the remembered side never changes another role's.
 */
export function roleHomePath(role: Role, side: PartsSide = readRememberedSide()): string {
  switch (role) {
    case "parts":
    case "parts_manager":
      return sideHomePath(side);
    case "service_advisor":
    case "technician":
      return "/workspace?view=my_vehicles";
    case "service_manager":
    case "shop_foreman":
    case "dispatcher":
      return "/workspace?view=all_active";
  }
}

export function RoleHomeRedirect() {
  const { user } = useSession();
  if (!user) return <Navigate to={LOGIN_PATH} replace />;
  return <Navigate to={roleHomePath(user.role)} replace />;
}
